module.exports = __webpack_public_path__ + "static/media/showcase.834b2310.svg";